import MineDamageLogic from "../../../logic/MineDamageLogic";
import { Settings } from "../../../Settings";
import NumberFormatter from "../../../util/NumberFormatter";
import Totals from "../../crew/Totals";
import Values from "../../value/Values";
import SkillNode from "../SkillNode";

export default class BlocksBonusSkillNode extends SkillNode {
    /**
     * @param {string} id 
     * @param {string} description 
     * @param {Totals} totals
     * @param {string} iconFileName 
     * @param {BigNum} cost 
     * @param {Values} values
     * @param {MineDamageLogic} mineDamageLogic
     * @param {number} purchaseIndex Starts at 0
     */
    constructor(id, totals, iconFileName, cost, purchaseListener, values, mineDamageLogic, purchaseIndex) {
        super(id, 'Mined Blocks +' + NumberFormatter.formatNumber(Settings.blocks.baseBonusPerUpgrade + (Settings.blocks.incrementBonusPerUpgrade * purchaseIndex)), null, totals, 
            iconFileName, cost, purchaseListener);

        /**
         * @constant
         * @type {Values}
         */
        this.values = values;
        /**
         * @constant
         * @type {MineDamageLogic}
         */
        this.mineDamageLogic = mineDamageLogic;
        /**
         * @constant
         * @type {number}
         */
        this.purchaseIndex = purchaseIndex;
    }

    // 

    /**
     * @returns {string}
     */
    getDescription() {
        // This is the total damage and must be the same as in MineDamageLogic.  
        const bonus = this.values.skillBlockBonusMultiplier.getValue() + Settings.blocks.multiplierPerBlock;
        return 'Damage / Block: ' + NumberFormatter.formatNumber(bonus);
    }

    /**
     * @override
     */
    onPurchase() {
        if (super.onPurchase()) {
            this.applyUpgrade();
            this.mineDamageLogic.calculateTotalMineDamagePerTurn();
            return true;
        }
        else {
            return false;
        }
    }

    /**
     * @override
     */
    onPurchaseFromSave() {
        this.applyUpgrade();
        super.onPurchaseFromSave();
    }

    /**
     * @private
     */
    applyUpgrade() {
        const bonus = Settings.blocks.baseBonusPerUpgrade + (Settings.blocks.incrementBonusPerUpgrade * this.purchaseIndex);
        this.values.skillBlockBonusMultiplier.incrementValue(bonus);
    }

}